import React from 'react';
import { Avatar } from '@mui/material';
import type { AvatarProps } from '@mui/material';
import { ReactNode } from 'react';
import SparkImageLoader from './SparkImageLoader';

interface SparkAvatarProps extends Omit<AvatarProps, 'sx'> {
  width?: string;
  height?: string;
  icon?: ReactNode;
  rounded?: boolean;
  sx?: AvatarProps['sx'];
}

function SparkAvatarBackground({
  width,
  height,
  icon,
  rounded = false,
  sx = {},
  ...rest
}: SparkAvatarProps) {
  const gradientColors =
    'linear-gradient(95deg, #F4821F, #EF5251, #DD529C, #6268AF)';
  const { src, ...restProps } = rest || {};

  if (!!src) {
    return (
      <SparkImageLoader
        width={width || '48px'}
        height={height || '48px'}
        style={{ borderRadius: '10px' }}
        src={src}
        alt=''
      />
    );
  }

  return (
    <Avatar
      sx={{
        width: width || '48px',
        height: height || '48px',
        background: gradientColors,
        borderRadius: rounded ? '50%' : '10px',
        ...sx,
      }}
      src={src}
      {...restProps}
    >
      {!!src ? <></> : icon}
    </Avatar>
  );
}

export default SparkAvatarBackground;
